import { Base } from '@studiometa/js-toolkit';
import { nextTick } from '@studiometa/js-toolkit/utils';

/**
 * @typedef {{
 *   $refs: {
 *     content: HTMLScriptElement;
 *   }
 * }} LazyHydrateProps
 */

/**
 * LazyHydrate class.
 * @augments {Base<LazyHydrateProps>}
 */
export default class LazyHydrate extends Base {
  /**
   * Config.
   */
  static config = {
    name: 'LazyHydrate',
    refs: ['content'],
  };

  /**
   * Hydrate the DOM with the content of the `content` ref.
   */
  async hydrate() {
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.$refs.content.textContent, 'text/html');
    this.takeChildrenFromTo(doc.body, this.$el);
    this.$root.$update();
    await nextTick();
  }

  /**
   * Take children from A and append then to B.
   * @param   {Element} fromElement
   * @param   {Element} toElement
   */
  takeChildrenFromTo(fromElement, toElement) {
    while (fromElement.childNodes.length > 0) {
      toElement.append(fromElement.childNodes[0]);
    }
  }
}
